var _circle, _ellipse, _path, _ellipse2, _ellipse3, _circle2, _g, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataOperations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 26,
    fill: "#F3F9FD",
    stroke: "#0078D4",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 26,
    rx: 10,
    ry: 4,
    fill: "#0078D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26v14c0 2.2 4.5 4 10 4s10-1.8 10-4V26",
    fill: "#0078D4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 33,
    rx: 10,
    ry: 4,
    fill: "#006CBE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 40,
    rx: 10,
    ry: 4,
    fill: "#005A9E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 44,
    r: 8,
    fill: "white",
    stroke: "#0078D4",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0078D4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 36.5,
    width: 1.4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 48.5,
    width: 1.4,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 43.3,
    width: 3,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 43.3,
    width: 3,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 38.7,
    width: 2.5,
    height: 1.2,
    transform: "rotate(-45 38 39.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 47,
    width: 2.5,
    height: 1.2,
    transform: "rotate(-45 46 47.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 38.7,
    width: 2.5,
    height: 1.2,
    transform: "rotate(45 46 39.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 47,
    width: 2.5,
    height: 1.2,
    transform: "rotate(45 38 47.6)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 44,
    r: 2.5,
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOperations);
export default __webpack_public_path__ + "static/media/Data Operations.2f8c4b2146fa85ba0fa269206393d5a8.svg";
export { ForwardRef as ReactComponent };